// eslint-disable-next-line import/no-named-as-default
import RetrievePasswordContainer from './RetrievePasswordContainer';

export default RetrievePasswordContainer;